module.exports = __webpack_public_path__ + "static/zwanger-ruglig-64a0c9d7a82d31f710b79ba775e91cac.jpg";